@if (loading()) {
    <mat-spinner></mat-spinner>
} @else if (error()) {
    <p>{{ "error_page.general_error_message" | transloco }}</p>
} @else if (dataSource()) {
    @for (report of trackingReports(); track report) {
        <loren-base-map
                [mapHeight]="400"
                [location]="report.startLocation"
                [tracePoints]="trace()"
                [markerImage]="report.avatar | lorenImage | async">
        </loren-base-map>
    }
} @else {
    <p>{{ "chart.no_data_available" | transloco }}</p>
}
